import React, { FC, memo } from 'react';

import HelpCenterLink from 'application/components/HelpCenterLink';
import { ModalTypes, useModalContext } from 'application/providers/ModalProvider';
import SimplyToolbar from 'application/components/SimplyToolbar';
import { HELP_CENTER_REPORTS_LINK } from 'application/pages/constants';

import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';

import { TEXTS } from './texts';

interface ReportToolbarProps {
  rightholderId: string;
  rightholderTitle: string;
  showButton: boolean;
  helpLink?: string;
  onHelpCenterClick: () => void;
  refetchReports: () => void;
}

export const ReportToolbar: FC<ReportToolbarProps> = memo(
  ({ showButton, helpLink = HELP_CENTER_REPORTS_LINK, onHelpCenterClick, refetchReports }) => {
    const { isMobile } = useMedia();
    const { openModal } = useModalContext();

    const onOpenReportClick = () => {
      openModal(ModalTypes.REPORT_CREATE_AD_CAMPAIGNS, {
        refetchReports,
      });
    };

    return (
      <SimplyToolbar
        ButtonSuffix={
          !isMobile && (
            <HelpCenterLink
              link={helpLink}
              onClick={onHelpCenterClick}
              elementId="reports_help_center"
            />
          )
        }
        createButtonTitle={TEXTS.REQUEST_REPORT_BUTTON_TEXT}
        onButtonClick={onOpenReportClick}
        showButton={showButton}
      />
    );
  }
);
